<template>
  <div>
    <div class="ShowCreateMelkUser">
      <el-scrollbar height="100%" ref="scrollbar">
        <div class="createMelkHeader phoneBookHeader">
          <div class="createMelkHeaderContainer">
            <div class="createMelkHeaderTitle">
              <h1>قراردادهای ثبت شده</h1>
            </div>
            <div class="showFormBtn" @click="formTypeHandler('form')">
              <i class="fa-solid fa-plus"></i>
            </div>
            <div @click="closeBtn" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>
          </div>
        </div>

        <div class="showFileMain">
          <div class="mainFilterBox" :class="{ show: showFilter }">
            <div class="fiterboxHeader">
              <div class="filterTitle">فیلتر</div>
              <div class="ShowIconVsIcon" @click="formCloseHandler('filter')">
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
            <div class="filterInputsWrapper">
              <div class="filterInputGroup">
                <input
                  class="filterGroupInput"
                  placeholder="عنوان قرارداد"
                  v-model="fillter.title"
                  type="text"
                />
              </div>

              <div class="filterInputGroup">
                <el-select
                  v-model="fillter.date_search_filed"
                  placeholder="جستجو براساس"
                  size="large"
                  style="
                    background: #f5f5f5;
                    min-width: 130px;
                    border-radius: 10px !important;
                    padding: 0 !important;
                  "
                >
                  <el-option
                    v-for="item in date_search_filed"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <div class="filterInputGroup">
                <DatePicker
                  clearable
                  v-model="fillter.date"
                  input-format="jYYYY-jMM-jDD"
                  format="YYYY-MM-DD"
                  placeholder="تاریخ را وارد کنید"
                />
              </div>
              <div class="filterInputGroup">
                <el-select
                  v-model="fillter.order_by"
                  placeholder="مرتب سازی براساس"
                  size="large"
                  style="
                    background: #f5f5f5;
                    min-width: 130px;
                    border-radius: 10px !important;
                    padding: 0 !important;
                  "
                >
                  <el-option
                    v-for="item in sorts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <div class="filterInputGroup">
                <el-select
                  v-model="fillter.cat_id"
                  placeholder=""
                  size="large"
                  style="
                    background: #f5f5f5;
                    min-width: 130px;
                    border-radius: 10px !important;
                    padding: 0 !important;
                  "
                >
                  <el-option :label="'همه قرارداد ها'" :value="'all'" />
                  <el-option :label="'مبایعه نامه'" :value="'1'" />
                  <el-option :label="'اجاره نامه'" :value="'2'" />
                </el-select>
              </div>
            </div>
            <div class="filterBtnsWrapper">
              <el-switch
                @click="load_post('first')"
                v-model="fillter.sarresid"
                class="ml-2"
                inline-prompt
                style="
                  --el-switch-on-color: #0096c7;
                  --el-switch-off-color: #374151;
                "
                active-text="سررسید شده"
                inactive-text="کلی"
              />
              <div class="filterBTn" @click="load_post('first', true)">
                <div class="filterBtnTitle">
                  <span class="filterBtnTitleRes">نمایش</span> فیلتر
                </div>
                <div class="filterBtnIcon">
                  <VsxIcon
                    iconName="Setting4"
                    :size="14"
                    color="#fff"
                    type="linear"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="resSearchGroup">
            <div class="searchInputWrapper">
              <input
                type="search"
                class="searchInput"
                placeholder="جستجوی قرارداد"
                v-model="fillter.title"
                inputmode="search"
                enterkeyhint="search"
                @keyup.enter="load_post('first')"
              />
              <div class="searchBtn">
                <i class="fas fa-search"></i>
              </div>
            </div>
            <div class="searchFilterBtn">
              <VsxIcon iconName="Sort" :size="20" color="#000" type="linear" />
              <el-select v-model="fillter.cat_id" @change="load_post('first')">
                <el-option label="همه قرارداد ها" :value="'all'" />
                <el-option label="مبایعه نامه" :value="'1'" />
                <el-option label="اجاره نامه" :value="'2'" />
              </el-select>
            </div>
          </div>
          <div class="resFilterBtnWrapper">
            <el-switch
              @click="load_post('first')"
              v-model="fillter.sarresid"
              class="ml-2"
              inline-prompt
              style="
                --el-switch-on-color: #0096c7;
                --el-switch-off-color: #374151;
              "
              active-text="سررسید شده"
              inactive-text="کلی"
            />
            <div class="resFilterBtn" @click="formOpenHandler('filter')">
              <div class="resAddBtnIcon">
                <VsxIcon
                  iconName="Setting4"
                  :size="14"
                  color="#fff"
                  type="linear"
                />
              </div>
              <div class="resAddBtnTitle">فیلتر</div>
            </div>
          </div>
          <div class="filesList" v-show="post_list.length > 0 && !isLoading">
            <div
              class="rentThumb"
              v-for="(typeMelks, index) in post_list"
              :key="index"
            >
              <div class="thumbPic">
                <img :src="typeMelks.avatar" alt="" />
              </div>
              <div class="thumbContent">
                <div class="contentWrapper">
                  <div class="contentHeader">
                    <div class="headerTitle">
                      {{ typeMelks.content }}
                    </div>
                    <div class="thumbCatWrapper">
                      <div
                        v-if="typeMelks.contract.cat_id == 1"
                        class="thumbCat"
                      >
                        مبایعه نامه
                      </div>
                      <div
                        v-if="typeMelks.contract.cat_id == 2"
                        class="thumbCat"
                      >
                        اجاره نامه
                      </div>
                    </div>
                    <div
                      v-if="
                        typeMelks &&
                        typeMelks.contract &&
                        typeMelks.contract.consultant_id
                      "
                      class="headerInfoWrapper"
                    >
                      <div class="infoTitle">مباشر:</div>
                      <div class="infoValue">
                        {{ typeMelks.contract.consultant_name }}
                      </div>
                    </div>
                    <div class="headerInfoWrapper">
                      <div
                        v-if="typeMelks.contract.cat_id == 1"
                        class="infoTitle"
                      >
                        خریدار:
                      </div>
                      <div v-else class="infoTitle">مستاجر:</div>
                      <div class="infoValue">
                        {{ typeMelks.contract.tenant }}
                      </div>
                    </div>
                    <div class="headerInfoWrapper">
                      <div
                        v-if="typeMelks.contract.cat_id == 1"
                        class="infoTitle"
                      >
                        فروشنده:
                      </div>
                      <div v-else class="infoTitle">موجر:</div>
                      <div class="infoValue">
                        {{ typeMelks.contract.lessor }}
                      </div>
                    </div>
                    <div class="headerInfoWrapper">
                      <div class="infoTitle">تاریخ ثبت:</div>
                      <div class="infoValue">
                        {{ typeMelks.contract.contract_date }}
                      </div>
                    </div>
                    <div
                      v-if="typeMelks.contract.cat_id == 2"
                      class="headerInfoWrapper"
                    >
                      <div class="infoTitle">تاریخ سررسید:</div>
                      <div class="infoValue">
                        {{ typeMelks.contract.end_date }}
                      </div>
                    </div>
                  </div>
                  <div class="contentMain">
                    <div v-if="typeMelks && typeMelks.contract && typeMelks.contract.panel_details" class="mainInfoWrapper">
                      <div class="infoTitle">توضیحات:</div>
                      <div class="infoValue">
                        {{ typeMelks.contract.panel_details }}
                      </div>
                    </div>
                    <div class="mainInfoWrapper">
                      <div class="infoTitle">آدرس:</div>
                      <div class="infoValue">
                        {{ typeMelks.address }}
                      </div>
                    </div>
                    <div class="mainPriceWrapper">
                      <div
                        v-if="typeMelks.contract.cat_id == 1"
                        class="priceThumb"
                      >
                        <div class="thumbTitle">قیمت:</div>
                        <div class="thumbValue">
                          {{ typeMelks.contract.total_price }}
                        </div>
                      </div>
                      <div
                        v-if="typeMelks.contract.cat_id == 2"
                        class="priceThumb"
                      >
                        <div class="thumbTitle">مبلغ رهن:</div>
                        <div class="thumbValue">
                          {{ typeMelks.contract.mortgage_price }}
                        </div>
                      </div>
                      <div
                        v-if="typeMelks.contract.cat_id == 2"
                        class="priceThumb"
                      >
                        <div class="thumbTitle">مبلغ اجاره:</div>
                        <div class="thumbValue">
                          {{ typeMelks.contract.rent_price }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="contentFooter">
                  <div
                    v-if="editLoading != typeMelks.contract.id"
                    class="footerButton editBtn"
                    @click="formTypeHandler('edit', typeMelks.contract.id)"
                  >
                    <i class="fas fa-edit"></i>
                    <div class="buttonTitle">ویرایش</div>
                  </div>
                  <divdiv
                    v-if="editLoading == typeMelks.contract.id"
                    class="footerButton editBtn"
                  >
                    <span class="editLoader"></span>
                  </divdiv>
                  <div
                    class="footerButton trashBtn"
                    @click="del_contract(typeMelks.contract.id)"
                  >
                    <i class="fas fa-trash"></i>
                    <div class="buttonTitle">حذف</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="loadeMoreLoader" v-if="loadmore_loading">
            <span class="custom-loader"></span>
          </div>
          <div
            ref="loadMoreTrigger"
            class="trigger"
            v-show="post_list.length > 0 && !isLoading"
          ></div>
          <div
            v-if="post_list.length == 0 && !isLoading"
            class="justify-center align-center mt-4"
            style="text-align: center; height: 90%"
          >
            <img
              src="/img/notfound.png"
              alt="Alt text"
              width="320"
              height="280"
            />
            <h2 class="nothing" style="font-size: 14px">قراردادی یافت نشد!</h2>
          </div>
        </div>
      </el-scrollbar>
      <editContract
        v-if="showEdit"
        :noteBookContract="true"
        :contractId="contractId"
        :BranchInfos="branch_infos"
        @close="formCloseHandler"
      />
    </div>
  </div>
</template>

<script>
import "@majidh1/jalalidatepicker/dist/jalalidatepicker.min.css";
import "@majidh1/jalalidatepicker";
import DatePicker from "@alireza-ab/vue3-persian-datepicker";
// import { Skeletor } from "vue-skeletor";
import { nextTick } from "vue";
import editContract from "./editContract.vue";
import { toast } from "vue3-toastify";
export default {
  name: "ShowRent",
  components: { DatePicker, editContract },
  props: {
    BranchInfos: Object,
  },
  data() {
    return {
      // publicPath: process.env.VUE_APP_PUBLIC_PATH,
      contractId: 0,
      ShowModel: false,
      editLoading: false,
      color: "",
      value: "",
      showFile: false,
      isFilterOpen: false,
      loadMoreTrigger: null,
      branch_infos: [],
      sorts: [
        { value: "newest", label: "جدیدترین" },
        { value: "top_view", label: "پر بازدیدترین" },
        { value: "cheapest", label: "ارزان ترین" },
        { value: "expensive", label: "گران ترین" },
      ],

      date_search_filed: [
        { value: "end_date", label: "جستجو براساس تاریخ سررسید" },
        { value: "contract_date", label: "جستجو براساس تاریخ ثبت" },
      ],
      divTop: "0",
      widthTop: "100%",
      dynamicStyles:
        "height: 0; overflow: hidden; transition: height 0.3s ease;",
      loadmore: false,
      loadmore_loading: false,
      fillter: {
        title: "",
        cat_id: "all",
        min_price: "0",
        max_price: "0",
        page: 1,
        order_by: "newest",
        branch_id: 0,
        sarresid: false,
        per_page: 12,
        // list_type:'own_profile',
        date: "",
        role: "branch_admin",
        consultant: 0,
        date_search_filed: "end_date",
        consultant_id:'',
      },
      isLoading: false,
      post_list: [],
      consultant_list: [],
      formToggled: false,
    };
  },
  computed: {
    showFilter() {
      return this.$route.query.filter === "active"
    },
    showEdit() {
      return this.$route.query.editing === "active"
    },
  },
  watch: {
    showFile(newValue) {
      document.body.style.overflow = newValue ? "hidden" : "auto";
    },
    formToggled(newValue) {
      this.$emit("filterStatus", newValue);
    },
    showEdit() {
      if (!this.showEdit) {
        this.editLoading = null;
      }
    }
  },
  async mounted() {
    setInterval(() => {
      this.loadTheme();
    }, 100);
    this.load_post("first");
    this.load_consultant();
    this.ShowToUser();
    this.get_branch_info;

    window.jalaliDatepicker.startWatch({
      maxDate: "today",
    });
    await nextTick();
    this.loadMoreTrigger = this.$refs.loadMoreTrigger;
    this.$nextTick(() => {
      const wrap = this.$refs.scrollbar?.wrapRef;
      if (wrap) {
        wrap.addEventListener("scroll", this.handleScroll);
      }
    });
  },
  beforeUnmount() {
    const wrap = this.$refs.scrollbar?.wrapRef;
    if (wrap) {
      wrap.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    del_contract(id) {
      this.$swal
        .fire({
          title: "قرارداد حذف گردد؟",
          text: "پس از این عملیات قرارداد برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              this.helperPost("contract-delete", { entity_id: id })

                .then((r) => {
                  console.log("result", r.data);
                  if (r.data.success == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    self.load_post("first");
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
    get_branch_info() {
      this.helperGet("branch-infos").then((res) => {
        this.branch_infos = res.data.data;
      });
    },
    clearForm() {
      this.fillter = {
        title: "",
        cat_id: "all",
        min_price: "0",
        max_price: "0",
        page: 1,
        order_by: "newest",
        branch_id: 0,
        sarresid: false,
        per_page: 12,
        // list_type:'own_profile',
        date: "",
        role: "branch_admin",
        consultant: 0,
        date_search_filed: "end_date",
        consultant_id:'',
      };
    },
    formTypeHandler(type, id = null) {
      this.formType = type;
      this.contractId = id;

      this.formOpenHandler(type);
    },
    formOpenHandler(type) {
      const query = { ...this.$route.query };
      delete query.filter;
      delete query.editing;
      this.editLoading = this.contractId;

      if (type == "form") {
        this.$router.push('/profile/createContract');
        return;
      } else if (type == "filter") query.filter = "active";
      else if (type == "edit") query.editing = "active";

      this.$router.push({ query });
    },
    formCloseHandler() {
      history.back();
    },
    load_post(param, close = false) {
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      this.fillter.consultant_id = this.$store.state.auth.role == 'consultant' ? this.$store.state.auth.uid : 0;
      if (param == "first") {
        this.isLoading = true;
        this.post_list = [];
        this.fillter.page = 1;
      }

      this.fillter.branch_id = this.BranchInfos.id;
      this.helperPost("contract-list", this.fillter).then((r) => {
        if (r.data.result == 0) {
          this.post_list = [];
          if (param != "first") {
            this.fillter.page -= 1;
          }
        } else {
          this.fillter.sarresid = r.data.data.sarresid;
          this.post_list = this.post_list.concat(r.data.data.list);
          if (r.data.data.total_page == this.fillter.page) {
            this.loadmore = false;
          }
        }
        this.isLoading = false;
        this.loadmore_loading = false;
      });
      let windowWidth = window.innerWidth;
      if (windowWidth < 1000 && close) {
        this.formCloseHandler("filter");
      }
    },
    load_consultant() {
      this.helperPost("branch-users-list", { role: "consultant" }).then((r) => {
        this.consultant_list = r.data.list;
      });
    },
    handleScroll() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      // لیزی لود: اگر ۱۰۰ پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_post(); // متد لود داده‌هات
        }
      }

      // تغییر وضعیت یک div (مثلاً موقعیت فیلتر بالای صفحه)
      if (scrollTop > 100) {
        this.divTop = "top:20px; width:85%;margin: 0;right: 5%";
      } else {
        this.divTop = "top:80px; width:90%;margin: auto";
      }
    },

    ShowToUser() {
      this.showFile = true;
    },

    closeBtn() {
      history.back()
      this.showFile = false;
      document.body.style = "overflow-y: auto;";
    },

    loadTheme() {
      const width = window.innerWidth;
      this.color = width >= 1250 ? "#2dc653" : "#f5f5f5";
    },

    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;

      this.dynamicStyles = this.isFilterOpen
        ? "height: 470px; overflow: hidden; transition: height 0.3s ease;"
        : "height: 0; overflow: hidden; transition: height 0.3s ease;";

      if (this.isFilterOpen) {
        setTimeout(() => {
          this.dynamicStyles =
            "height: 470px; overflow: inherit; transition: height 0.3s ease;";
        }, 300);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.topNav__searchbar_wrapper {
  width: 60% !important;
}
.loadButtonarea {
  width: 100%;
  margin-top: 36px;
}
.loadButtonarea .loadButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  text-align: center;
  background: #2dc653;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.9rem;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}
.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.SearchBoxToUser {
  grid-template-columns: 20% 20% 18% 12% 10% 8% 7% !important;
}

.contentWrapper {
  min-height: 323px;
}

.footerButton.editBtn {
  min-width: 90px !important;
  min-height: 29.5px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resSearchGroup {
  display: none;
}

.editLoader {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.dark {
  .thumbCatWrapper {
    .thumbCat {
      background: #25292e;
    }
  }
}

.thumbCatWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;

  .thumbCat {
    padding: 4px 8px;
    font-size: 0.75rem;
    line-height: 1.25rem;
    display: flex !important;
    align-items: center !important;
    gap: 4px;
    border-radius: 24px;
    color: #fff;
    height: 21px;
    white-space: nowrap !important;
    background: #f7f7f7;
    color: #0096c7;
  }
}

@media (max-width: 700px) {
  .contentWrapper {
    min-height: auto;
  }
}
</style>
